import { RuleApplySignType, RuleConditionType, RuleGroup } from "@/types/role.types.ts";
import { SelectItem } from "@skailer-com/uikit";

export const serviceUserEntitiesToAssignTo = (entities: SelectItem[]): RuleGroup[] =>
  entities.length > 0
    ? [
        {
          rules: [
            {
              condition_type: RuleConditionType.employee,
              sign: RuleApplySignType.include,
              condition_ids: entities.map((entity) => Number(entity.id)),
              value_ids: [],
              condition_entities: entities,
              value_entities: [],
            },
          ],
        },
      ]
    : [];

export const assignToToServiceUserEntities = (groups: RuleGroup[]): SelectItem[] =>
  groups.flatMap((group) => group.rules).flatMap((rule) => rule.condition_entities);
